import ProductItems from 'components/ProductItems';
import './styles.scss';
import { Button } from 'components/buttons/Button/Button';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { ROUTES } from 'constants/routes';
import { selectCropNutritionForProduct, fetchCropNutritionForProduct } from 'store/slices/CropNutritionSlice';
import { type_nutrition } from 'api/constants';

const CropNutritionBox = ({ title }) => {
    const dispatch = useDispatch();
    const { slug } = useParams();
    // TODO add pagination
    const { data, next } = useSelector(selectCropNutritionForProduct);

    useEffect(() => {
        // @ts-ignore
        dispatch(fetchCropNutritionForProduct({ slug, type: type_nutrition }));
    }, [dispatch, slug]);

    return (
        <div className="box product-box">
            {title && <h3>{title}</h3>}
            {data?.length && <ProductItems data={data} baseRoute={ROUTES.cropNutritionPrograms} />}
            {/* <Button type="show-more">SHOW MORE</Button> */}
        </div>
    );
};
export default CropNutritionBox;
